import React, { createContext, useContext } from "react";

const AproveitamentoContext = createContext();

export const AproveitamentoProvider = ({ children }) => {
  const today = new Date();

  const buscarAproveitamentos = async (
    mes,
    ano,
    idResponsavel,
    idRestaurante
  ) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);
      const isValid = (v) => v != null && v !== "" && String(v) !== "undefined";
      const params = new URLSearchParams({ mes, ano });
      if (isValid(idRestaurante)) params.append("restauranteId", idRestaurante);
      if (isValid(idResponsavel)) params.append("idResponsavel", idResponsavel);
      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/aproveitamentos?${params}`,
        {
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
        }
      );

      if (response.ok) {
        return await response.json();
      } else {
        throw new Error(`Erro ${response.status}: ${response.statusText}`);
      }
    } catch (error) {
      console.error("Erro ao buscar aproveitamentos:", error);
      throw error;
    }
  };

  const salvarAproveitamento = async (novoAproveitamento, restauranteId) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/aproveitamentos?restauranteId=${restauranteId}`,
        {
          method: "POST",
          headers: {
            "Content-Type": "application/json",
            Authentication: access_token,
          },
          body: JSON.stringify(novoAproveitamento),
        }
      );
      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `Erro ${response.status}: ${response.statusText}`
        );
      }
      return true;
    } catch (error) {
      console.error("Erro ao salvar aproveitamento:", error);
      throw error;
    }
  };

  const deleteAproveitamento = async (aproveitamentoId, restauranteId) => {
    try {
      const user = sessionStorage.getItem("user");
      const { access_token } = JSON.parse(user);

      const response = await fetch(
        `${process.env.REACT_APP_BASE_URL}/api/v1/aproveitamentos/${aproveitamentoId}?restauranteId=${restauranteId}`,
        {
          method: "DELETE",
          headers: {
            Authentication: access_token,
          },
        }
      );

      if (!response.ok) {
        const errorData = await response.json();
        throw new Error(
          errorData.message || `Erro ${response.status}: ${response.statusText}`
        );
      }
      return true;
    } catch (error) {
      console.error("Erro ao excluir aproveitamento:", error);
      throw error;
    }
  };

  return (
    <AproveitamentoContext.Provider
      value={{
        buscarAproveitamentos,
        salvarAproveitamento,
        deleteAproveitamento,
        today,
      }}
    >
      {children}
    </AproveitamentoContext.Provider>
  );
};

export const useAproveitamento = () => useContext(AproveitamentoContext);